export const PREVIOUS_VIRTUAL_OFFICE_URL = 'https://ov.gomezgroupmetering.com/?usertype=prop';
export const PROPERTY_MANAGERS_OFFICE_URL = 'https://ov.gomezgroupmetering.com/?usertype=admin';
export const FIXED_NETWORKS_OFFICE_URL = 'https://ovggm.gomezgroupmetering.com';

const HAS_LOGGED_IN_KEY = 'ggm_ov_has_logged_in';

export function hasLoggedInOnce(): boolean {
  try {
    return localStorage.getItem(HAS_LOGGED_IN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markLoggedInOnce(): void {
  try {
    localStorage.setItem(HAS_LOGGED_IN_KEY, '1');
  } catch {
    // Storage can be unavailable in private mode.
  }
}
